/**
 *
 * @/functions/undo.js
 *
 * Description:
 * Useful functions to handle the edit scale UNDO feature
 *
 */

//
// Confirma se o NÓ é proibido
//

export const isProtectedPath = (path, groupID, scaleID) => {
  // Remove "/" do início e fim
  const normalized = path.replace(/^\/+|\/+$/g, '')

  const allProtected = [
    "escalas",
    "plantoes",
    "grupos",
    "users",
    "logs",
    "consultas",
    "plantoes_sinalizados",
    "consultassolicitadas",
    "chats",
    `escalas/${groupID}`,
    `escalas/${groupID}/${scaleID}`
  ]

  return allProtected.includes(normalized)
}
